module.exports = __webpack_public_path__ + "static/media/bg.987f7bd2.png";